// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__27QUH","notes":"Notes_notes__DxM06","note":"Notes_note__3zCos","markdown":"Notes_markdown__1ZdUx"};